import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    descricaoMenu,
} from '../../../business-components/String/String'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    TabsPadrao,
    TabPadrao,
} from '../../../business-components/Tab/Tab'

import tabSimulacaoFinanceiraFormList from '../../../business-rules/List/tabSimulacaoFinanceiraFormList'

import SimulacaoFinanceiraForm from './SimulacaoFinanceiraForm'

import MapaFinanceiroForm from '../mapaFinanceiro-form/MapaFinanceiroForm'

import EstudoReportPrimeiraReuniaoCliente from '../estudo-report/EstudoReportPrimeiraReuniaoCliente'

import EstudoReportPrimeiraReuniaoInvestimento from '../estudo-report/EstudoReportPrimeiraReuniaoInvestimento'

import EstudoReportPrimeiraReuniaoSeguroVida from '../estudo-report/EstudoReportPrimeiraReuniaoSeguroVida'



const SimulacaoFinanceiraFormMenu = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, vars, linhaFormList, tabClienteFormList }) => {

    const tabAnaliseFinanceiraFormListAux =
        tabSimulacaoFinanceiraFormList(linhaFormList, tabClienteFormList, values.formListRadioGroup, values.jsonAcessoCliente)
    
    const [tabIndexAnaliseFinanceira, setTabIndexAnaliseFinanceira] =
        useState(
            tabAnaliseFinanceiraFormListAux.length - 1 < values.tabIndexAnaliseFinanceira
                ?
                    0
                :
                    descricaoMenu(tabAnaliseFinanceiraFormListAux[values.tabIndexAnaliseFinanceira]) ===
                    LABEL.tabSimulacaoFinanceiraReportPrimeiraReuniaoCliente
                        ?
                            0
                        :
                            values.tabIndexAnaliseFinanceira
        )

    const handleTabChangeAnaliseFinanceira = (e, value) => {

        values.tabIndexAnaliseFinanceira = value

        values.formatoReport = HARDCODE.idFormatoReportApresentacao // replicado em useSingleton

        setTabIndexAnaliseFinanceira(value)
    }



    useSingleton(() => {

        values.formatoReport = HARDCODE.idFormatoReportApresentacao // replicado em handleTabChangeAnaliseFinanceira
    })



    return (
        <DivForm>
            {tabAnaliseFinanceiraFormListAux.length > 1 && (
                <TabsPadrao
                    value={tabIndexAnaliseFinanceira}
                    onChange={handleTabChangeAnaliseFinanceira}
                    level={2}
                >
                    {tabAnaliseFinanceiraFormListAux?.map((item, ind) => (
                        <TabPadrao
                            value={ind}
                            label={item}
                            key={ind}
                            level={2}
                        />
                    ))}
                </TabsPadrao>
            )}
            {descricaoMenu(tabAnaliseFinanceiraFormListAux[tabIndexAnaliseFinanceira]) ===
            LABEL.tabSimulacaoFinanceiraSimulacao && (
                <SimulacaoFinanceiraForm
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    handleSubmitAutomatico={handleSubmitAutomatico}
                    vars={vars}
                />
            )}
            {descricaoMenu(tabAnaliseFinanceiraFormListAux[tabIndexAnaliseFinanceira]) ===
            LABEL.tabSimulacaoFinanceiraMapaFinanceiro && (
                <MapaFinanceiroForm
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                />
            )}
            {descricaoMenu(tabAnaliseFinanceiraFormListAux[tabIndexAnaliseFinanceira])
            === LABEL.tabSimulacaoFinanceiraReportPrimeiraReuniaoCliente && (
                <EstudoReportPrimeiraReuniaoCliente
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    handleSubmitAutomatico={handleSubmitAutomatico}
                    vars={vars}
                    linhaFormList={linhaFormList}
                />
            )}
            {descricaoMenu(tabAnaliseFinanceiraFormListAux[tabIndexAnaliseFinanceira])
            === LABEL.tabSimulacaoFinanceiraReportPrimeiraReuniaoInvestimento && (
                    <EstudoReportPrimeiraReuniaoInvestimento
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        handleSubmitAutomatico={handleSubmitAutomatico}
                        vars={vars}
                    />
            )}
            {descricaoMenu(tabAnaliseFinanceiraFormListAux[tabIndexAnaliseFinanceira])
            === LABEL.tabSimulacaoFinanceiraReportPrimeiraReuniaoSeguroVida && (
                    <EstudoReportPrimeiraReuniaoSeguroVida
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        handleSubmitAutomatico={handleSubmitAutomatico}
                        vars={vars}
                    />
            )}
        </DivForm>
    )
}

export default SimulacaoFinanceiraFormMenu